export default function V75Mockup() {
  return (
    <div style={{
      width: '100vw', height: '100vh', backgroundColor: '#00FF00',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      {/* V75 Popup */}
      <div style={{ position: 'relative' }}>
        {/* Glow ring */}
        <div style={{
          position: 'absolute', inset: '-4px', borderRadius: '16px',
          background: 'linear-gradient(135deg, #C0C0C0, #FFD700, #C0C0C0)',
          backgroundSize: '200% 200%',
          opacity: 0.7,
        }} />
        <div style={{
          position: 'relative',
          background: 'linear-gradient(135deg, #1E3A5F 0%, #0F2440 80%, #1a1040 100%)',
          borderRadius: '14px',
          padding: '20px 44px 20px 44px',
          minWidth: '400px',
          maxWidth: '650px',
          textAlign: 'center',
          boxShadow: '0 0 40px rgba(192,192,192,0.25), 0 0 80px rgba(255,215,0,0.15), 0 20px 50px rgba(0,0,0,0.5)',
        }}>
          {/* V75 Logo bug - upper left, sticking out */}
          <img 
            src="/assets/v75-logo.png" 
            alt="V75"
            style={{
              position: 'absolute',
              top: '-20px',
              left: '-15px',
              width: '95px',
              height: '75px',
              objectFit: 'contain',
              filter: 'drop-shadow(2px 2px 6px rgba(0,0,0,0.5))',
            }}
          />
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: '0.65rem',
            fontWeight: 600,
            color: '#FFD700',
            textTransform: 'uppercase',
            letterSpacing: '4px',
            marginBottom: '10px',
          }}>
            V75 Informasjon
          </div>
          <div style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '1.4rem',
            fontWeight: 600,
            color: '#FFFFFF',
            lineHeight: 1.4,
            textShadow: '0 2px 8px rgba(0,0,0,0.3)',
          }}>
            V75 starter lørdag kl. 16:00 på Bjerke Travbane
          </div>
        </div>
      </div>
    </div>
  );
}
